import { Button, Table, Form, InputGroup, Pagination, Container } from "react-bootstrap";
import { MdSearch, MdVisibility, MdUnfoldMore, MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useState, useMemo, useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { Dimcontext } from "../../context/pagecontext";
import { toast, Zoom } from 'react-toastify';
import '../css/client/client.css';
import Sidebar from "../dashboard/sidebar";
// import { ViewAppClient } from "./viewAppClient"; 
import { EditAppClient } from "./editAppClient"; 
// import { AddAppClient } from "./addAppClient"; 
import { motion, AnimatePresence } from 'framer-motion';
import { Datacontext } from "../../context/dataContext";

export const AppClient = () => {
    const { user } = useContext(AuthContext);
    const { setDim } = useContext(Dimcontext);
    
    // Make sure 'appClients' is fetched and provided in your Datacontext
    const { appClients } = useContext(Datacontext); 
    
    const [searchTerm, setSearchTerm] = useState('');
    const [edit, set_edit] = useState({ active: false, id: '' });
    
    // Pagination & Sorting States
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const showToast = (msg) => toast.warn(msg, { theme: "dark", transition: Zoom, position: "bottom-center" });

    // Handle Sorting Logic
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    // Search & Sorting Logic
    const filteredAndSortedClients = useMemo(() => {
        const term = searchTerm.toLowerCase().trim();
        
        // 1. Filter
        let filtered = (appClients || []).filter(c => 
            c.name?.toLowerCase().includes(term) || 
            c.phoneNumber?.toString().includes(term) ||
            c.city?.toLowerCase().includes(term)
        );

        // 2. Sort
        if (sortConfig.key) {
            filtered.sort((a, b) => {
                // Handle null/undefined values safely
                const aValue = a[sortConfig.key] ? a[sortConfig.key].toString().toLowerCase() : '';
                const bValue = b[sortConfig.key] ? b[sortConfig.key].toString().toLowerCase() : '';

                if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        
        return filtered;
    }, [appClients, searchTerm, sortConfig]);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * rowsPerPage;
        return filteredAndSortedClients.slice(start, start + rowsPerPage);
    }, [filteredAndSortedClients, currentPage, rowsPerPage]);

    const totalPages = Math.ceil(filteredAndSortedClients.length / rowsPerPage);

    // Helper function to render the colored pill based on status
    const renderStatusPill = (status) => {
        const normalizedStatus = status?.toLowerCase();
        switch (normalizedStatus) {
            case 'approved':
                return <span className="badge rounded-pill bg-success">Approved</span>;
            case 'rejected':
                return <span className="badge rounded-pill bg-danger">Rejected</span>;
            case 'hold':
                return <span className="badge rounded-pill bg-warning text-dark">Hold</span>;
            default:
                return <span className="badge rounded-pill bg-secondary">Pending</span>; 
        }
    };

    return (
        <div className="dashboard-page">
            
            <div className="dashboard-wrapper">
                <div className='d-none' style={{backgroundColor:"#4a127e"}}>
                    <Sidebar user={user} />
                </div>

                <main className="main-area">
                    <Container fluid="xxl" className="py-4 px-3 px-md-4">
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="main-glass-card shadow-sm border">
                            <div className="card-header-custom d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3 gap-3">
                                <h4 className="m-0 fw-bold text-dark">App User Directory</h4>
                                
                                <div className="d-flex flex-wrap gap-2">
                                    <InputGroup className="search-bar" style={{ maxWidth: '300px' }}>
                                        <InputGroup.Text className="bg-white">
                                            <MdSearch size={20} className="text-muted" />
                                        </InputGroup.Text>
                                        <Form.Control 
                                            placeholder="Search app users..." 
                                            onChange={(e) => {setSearchTerm(e.target.value); setCurrentPage(1);}}
                                        />
                                    </InputGroup>
                                </div>
                            </div>

                            <div className="table-side-scroll-container">
                                <Table hover responsive className="imtable mb-0">
                                    <thead>
                                        <tr>
                                            <th className="sticky-col pin-no">NO.</th>
                                            <th className="sticky-col pin-name1 text-nowrap" onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                                                NAME <MdUnfoldMore />
                                            </th>
                                            <th className="text-nowrap">
                                                E-MAIL 
                                            </th>
                                            <th className="text-nowrap">
                                                PHONE
                                            </th>
                                            <th className="text-nowrap" onClick={() => handleSort('city')} style={{ cursor: 'pointer' }}>
                                                CITY <MdUnfoldMore />
                                            </th>
                                            <th className="text-nowrap text-center" onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                                                STATUS <MdUnfoldMore />
                                            </th>
                                            <th className="text-center">ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.length > 0 ? paginatedData.map((client, idx) => (
                                            <tr key={client.id} className="align-middle">
                                                <td className="sticky-col pin-no">{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                                                <td className="sticky-col pin-name1 fw-semibold">{client.name?.toUpperCase()}</td>
                                                <td>{client.email}</td>
                                                <td>{client.phoneNumber || 'N/A'}</td>
                                                <td>{client.city || 'N/A'}</td>
                                                
                                                {/* STATUS COLUMN */}
                                                <td className="fw-semibold text-center">
                                                    {renderStatusPill(client.status)}
                                                </td>

                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-1">
                                                            <Button className="btn-action be" onClick={() => {set_edit({active: true, id: client.id}); setDim(true);}}>
                                                                <MdVisibility /> View
                                                            </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr><td colSpan={7} className="text-center py-5 text-muted">No app users found.</td></tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Pagination Footer */}
                            <div className="pagination-footer d-flex flex-column flex-md-row justify-content-between align-items-center p-3 border-top bg-light gap-3">
                                
                                <div className="d-flex align-items-center gap-2">
                                    <span className="text-muted small">Rows per page:</span>
                                    <Form.Select 
                                        size="sm" 
                                        style={{ width: '80px', borderRadius: '6px' }}
                                        value={rowsPerPage} 
                                        onChange={(e) => { 
                                            setRowsPerPage(Number(e.target.value)); 
                                            setCurrentPage(1); 
                                        }}
                                    >
                                        {[10, 25, 50, 100].map(v => (
                                            <option key={v} value={v}>{v}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <div className="text-muted small fw-medium">
                                    {filteredAndSortedClients.length > 0 ? (
                                        <>
                                            Showing <b>{(currentPage - 1) * rowsPerPage + 1}</b> to <b>{Math.min(currentPage * rowsPerPage, filteredAndSortedClients.length)}</b> of <b>{filteredAndSortedClients.length}</b> users
                                        </>
                                    ) : (
                                        "No users available"
                                    )}
                                </div>

                                <Pagination className="mb-0 custom-pagination shadow-sm">
                                    <Pagination.First 
                                        disabled={currentPage === 1} 
                                        onClick={() => setCurrentPage(1)} 
                                    />
                                    <Pagination.Prev 
                                        disabled={currentPage === 1} 
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    >
                                        <MdKeyboardArrowLeft size={20} />
                                    </Pagination.Prev>

                                    <Pagination.Item active className="px-2">{currentPage}</Pagination.Item>

                                    <Pagination.Next 
                                        disabled={currentPage === totalPages || totalPages === 0} 
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    >
                                        <MdKeyboardArrowRight size={20} />
                                    </Pagination.Next>
                                    <Pagination.Last 
                                        disabled={currentPage === totalPages || totalPages === 0} 
                                        onClick={() => setCurrentPage(totalPages)} 
                                    />
                                </Pagination>
                            </div>
                        </motion.div>
                    </Container>
                </main>
            </div>

            <AnimatePresence>
                {edit.active && (
                    <motion.div
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        className="modal-overlay-wrapper"
                    >
                        <EditAppClient 
                            set_edit={(val) => set_edit({...edit, active: val})} 
                            id={edit.id} 
                            showToast={showToast} 
                        />
                    </motion.div>
                )}
            </AnimatePresence> 
        </div>
    );
};